import { CubeTimeDimensionGranularity, Weekdays } from "../../../enum/cube-schema.enum";
import { IWorkingSessionsAnalyticsActivityScoresEnum } from "../../../enum/working-sessions-analytics-activity.enum";
import { CubeConfigDto } from "../../common/request/cube-config.dto";

export interface QueryScoreTimeSeriesRequestParamsDto {
    startDate: string;
    endDate: string;
    granularity: CubeTimeDimensionGranularity;
    weekday?: Weekdays;
    score: IWorkingSessionsAnalyticsActivityScoresEnum;
}